import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Github = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.166 6.84 9.489.5.091.682-.218.682-.483 0-.237-.009-.866-.014-1.7-2.781.604-3.368-1.341-3.368-1.341-.455-1.155-1.11-1.462-1.11-1.462-.908-.62.068-.609.068-.609 1.004.072 1.532 1.031 1.532 1.031.892 1.528 2.34 1.087 2.91.831.091-.646.349-1.087.635-1.337-2.22-.252-4.555-1.11-4.555-4.942 0-1.091.39-1.984 1.03-2.683-.104-.253-.447-1.27.097-2.647 0 0 .84-.269 2.75 1.026a9.578 9.578 0 0 1 2.504-.338 9.592 9.592 0 0 1 2.503.338c1.91-1.295 2.747-1.026 2.747-1.026.546 1.377.203 2.394.1 2.647.64.699 1.028 1.591 1.028 2.683 0 3.842-2.338 4.687-4.566 4.934.359.31.679.92.679 1.852 0 1.337-.013 2.415-.013 2.743 0 .268.18.579.688.481 3.97-1.325 6.833-5.07 6.833-9.486C22 6.477 17.522 2 12 2"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Github;
